import React from 'react'
import styled from '@emotion/styled'
import { useStaticQuery, graphql } from 'gatsby'

const ReviewsContainer = styled.div`
  background-color: #d52924;
  color: #fff;
  box-shadow: 5px 5px 8px -4px rgba(0, 0, 0, 0.3);
  font-family: sans-serif;
  font-size: 11px;
  font-weight: 700;
  box-sizing: border-box;
  padding: 20px;
  width: 140px;
  height: 140px;
  border-radius: 50%;
  text-transform: none;
  text-align: center;
  text-transform: none;
  line-height: 16px;
`

const SvgContainer = styled.div`
  margin-top: 7px;

  svg {
    height: 13px;
    margin: 0 auto;
  }
`

const ReviewsNumber = styled.div`
  font-size: 30px;
  font-weight: 400;
  line-height: 30px;
`

const ReviewsWidgetCircular = () => {
  const data = useStaticQuery(graphql`
    {
      query1: allBirdeyedata(
        filter: { id: { ne: "dummy" }, sourceType: { ne: "Direct Feedback" } }
      ) {
        nodes {
          rating
        }
      }
      query2: allBirdeyedata(filter: { id: { ne: "dummy" }, rating: { ne: 0 } }) {
        nodes {
          rating
        }
      }
    }
  `)

  function length(obj) {
    return Object.keys(obj).length
  }
  const totalRatings = length(data.query1.nodes)
  const fiveFourThreeRatings = length(data.query2.nodes)

  // console.log(totalRatings)
  // console.log(fiveFourThreeRatings)

  let total = 0
  const ratingsTotal = data.query1.nodes
  let i
  for (i = 0; i < ratingsTotal.length; i += 1) {
    total += ratingsTotal[i].rating
  }
  // console.log(total);

  let averageRating = total / fiveFourThreeRatings
  averageRating = averageRating.toFixed(1)
  // console.log(averageRating)

  const rectWidth = `${averageRating * 20}%`
  // console.log(rectWidth)

  return (
    <ReviewsContainer>
      <ReviewsNumber>{totalRatings}</ReviewsNumber>
      Customer Reviews
      <SvgContainer>
        <svg viewBox="0 0 1000 200" className="rating">
          <defs>
            <polygon
              id="star"
              points="100,0 131,66 200,76 150,128 162,200 100,166 38,200 50,128 0,76 69,66 "
            />

            <clipPath id="stars">
              <use xlinkHref="#star" />
              <use xlinkHref="#star" x="20%" />
              <use xlinkHref="#star" x="40%" />
              <use xlinkHref="#star" x="60%" />
              <use xlinkHref="#star" x="80%" />
            </clipPath>
          </defs>

          <rect style={{ fill: '#dddddd', height: '100%', width: '100%' }} clipPath="url(#stars)" />

          <rect
            width={rectWidth}
            style={{ fill: '#EDBE2B', height: '100%' }}
            clipPath="url(#stars)"
          />
        </svg>
      </SvgContainer>
    </ReviewsContainer>
  )
}
export default ReviewsWidgetCircular
